import * as React from "react";
import type { SVGProps } from "react";
const SvgTablet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 17a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM6 3h12V1H6zm12 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v16h2V4zm0 16a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H6v2h12zM6 21a1 1 0 0 1-1-1H3a3 3 0 0 0 3 3zm-1-1V4H3v16zM5 4a1 1 0 0 1 1-1V1a3 3 0 0 0-3 3zm7 15h.01v-2H12z"
    />
  </svg>
);
export default SvgTablet;
